import { GenericMethods } from "layouts/aplicacoes/GenericMethods";
import { Sites } from "data/utils/globals";
import useCreate from "./hooks/useCreate";
import { SchemaData } from "./hooks/types";
import { CreateGql } from "./queries/create";
import useTemplate from "./hooks/useTemplate";

function Create() {
  const { template } = useTemplate(true);

  if (!template) return null;
  return (
    <GenericMethods.Create<SchemaData, CreateGql>
      siteId={Sites.UNIFTEC.id}
      sitePath={Sites.UNIFTEC.path}
      useCreate={useCreate}
      template={template}
    />
  );
}

export default Create;
